export const HOMEPAGE_CONSTANTS = {
  BACK_TO_HOME: "Back to home page",
  PORTAL_TITLE: "Skiply business portal",
  HAVE_QUESTIONS: "Have questions? We're here for you:",
  CONTACT_US: "contactus@skiply.ae",
  COPYRIGHT: "© Copyright by Rakbank 2024",
};

export const LOGINPAGE_CONSTANTS = {
  HEADER: "Welcome to Skiply Portal",
  CAPS_LOCK: "WARNING! Caps lock is ON.",
  FORGOT_PASSWORD: "Forgot password?",
  LOGIN_BUTTON: "Sign in",
  BACK_BUTTON: "Back to Skiply business portal",
  INVALID_EMAIL: "Please enter a correct email address",
  INVALID_USERNAME: "Invalid username or password",
  EMAIL_PLACEHOLDER: "Admin Email ID",
  LOGIN_EMAIL: "Email",
  LOGIN_PASSWORD: "Password",
  OTP_PLACEHOLDER: "OTP",
  CREATE_NEW_PASSWORD: "New Password",
  CONFIRM_NEW_PASSWORD: "Confirm Password",
};

export const FORGOT_PASSWORD_CONSTANTS = {
  STEP1_HEADER: "Forgot your password?",
  STEP1_SUBHEADER:
    "Please enter your admin email address to receive a one-time passcode (OTP).",
  STEP1_BUTTON: "Submit",
  BACK_BUTTON: "Back to Login",
  STEP2_HEADER: "Enter Verification Code",
  STEP2_SUBHEADER:
    "Check your email for the 6-digit code and enter it below to continue.",
  STEP2_BUTTON: "Confirm",
  INVALID_OTP: "Verify OTP UnSuccessfull",
  STEP3_HEADER: "Create a New Password",
  STEP3_SUBHEADER:
    "Enter and confirm your new password to complete the reset process.",
  STEP3_BUTTON: "Save",
  PASSWORD_UPDATE_FAILURE: "Error updating password. Please try again.",
  PASSWORD_VALIDATION_FAILURE:
    "Validation failure. Password must be between 8 and 16 characters, contain at least one number, one alphabetic character and one special character.",
  STEP_COMPLETE_HEADER: "Password Reset Successful",
  STEP_COMPLETE_SUBHEADER:
    "Your password has been updated. You can now log in with your new credentials.",
};

export const SMART_PLANS_CONSTANTS = {
  HEADER: "Smart plans",
  BREADCRUMB_SMART_PLANS: "Smart plans",
  EXPORT: "Export",
  CANCEL_PLAN_TITLE: "Cancel smart plan",
  CANCEL_PLAN_MESSAGE: "Are you sure you want to cancel this smart plan ?",
  CANCEL_PLAN_CONFIRM: "Yes, cancel",
  CANCEL_PLAN_BACK: "Back to details",
  CANCEL_SUCCESS: "Smart plan cancelled successfully",
  CANCEL_ERROR: "Failed to cancel smart plan. Please try again.",
  // SmartPlansList specific strings
  NO_DATA_MESSAGE: "No smart plans found",
  NO_DATA_SUBTITLE: "You have no smart plans yet",
  // SmartPlanDetails specific strings
  DETAIL_SCHEDULE_SUMMARY: "Schedule summary",
  DETAIL_STUDENT_DETAILS: "Student details",
  DETAIL_PAYMENT_SCHEDULE: "Payment schedule",
  DETAIL_INSTRUCTION_ID: "Instruction ID",
  DETAIL_STATUS: "Status",
  DETAIL_TOTAL_PAYMENTS: "Total number of payments",
  DETAIL_LAST_PAYMENT_STATUS: "Last payment status",
  DETAIL_DATE_CREATED: "Date created",
  DETAIL_START_DATE: "Start date",
  DETAIL_END_DATE: "End date",
  DETAIL_NEXT_PAYMENT_DATE: "Next payment date",
  DETAIL_TOTAL_AMOUNT: "Total amount",
  DETAIL_AMOUNT_PAID: "Amount paid",
  DETAIL_AMOUNT_DUE: "Amount due",
  DETAIL_STUDENT_NAME: "Student name",
  DETAIL_STUDENT_ID: "Student ID",
  DETAIL_GRADE: "Grade",
  DETAIL_PARENT_EMAIL: "Parent Email address",
  // Payment schedule columns
};

export const COMMON_PAYMENT_CONSTANTS = {
  SEARCH_BY: "Search by",
  FILTER_BY_STATUS: "Filter by Status",
  CLEAR_FILTERS: "Clear filters",
  STATUS_ACTIVE: "Active",
  STATUS_CANCELLED: "Cancelled",
  STATUS_COMPLETED: "Completed",
  STATUS_SUCCESS: "Success",
  STATUS_FAILED: "Failed",
  STATUS_PENDING: "Pending",
  PAYMENT_MONTH: "Month",
  PAYMENT_DUE_DATE: "Due date",
  PAYMENT_AMOUNT: "Amount",
  PAYMENT_STATUS: "Status",
  PAYMENT_RRN: "RRN",
  PAYMENT_FAILED_REASON: "Failed reason",
};

export const DIRECT_DEBIT_CONSTANTS = {
  HEADER: "Direct debit",
  BREADCRUMB_DIRECT_DEBIT: "Direct debit",
  SEARCH_PLACEHOLDER: "Search by Order ID or Customer name",
  CLEAR_SEARCH: "Clear search",
  NO_DATA_MESSAGE: "No mandates found",
  NO_DATA_SUBTITLE: "You have no direct debit mandates yet",
  DETAIL_MANDATE_DETAILS: "Mandate details",
  DETAIL_TRANSACTION_HISTORY: "Transaction history",
  PAUSE_MANDATE: "Pause mandate",
  CANCEL_MANDATE: "Cancel mandate",
  PAUSE_MANDATE_TITLE: "Pause",
  PAUSE_MANDATE_MESSAGE: "Are you sure you want to pause mandate with ID",
  PAUSE_MANDATE_CONFIRM: "Pause mandate",
  CANCEL_MANDATE_TITLE: "Cancel mandate",
  CANCEL_MANDATE_MESSAGE: "Are you sure you want to cancel this mandate",
  CANCEL_MANDATE_CONFIRM: "Yes, cancel",
  CANCEL_MANDATE_BACK: "Back to details",
  MODAL_CLOSE: "Close",
  PAUSE_SUCCESS: "Mandate paused successfully",
  PAUSE_ERROR: "Failed to pause mandate. Please try again.",
  CANCEL_SUCCESS: "Mandate cancelled successfully",
  CANCEL_ERROR: "Failed to cancel mandate. Please try again.",
  // Transaction history columns
  PAYMENT_RRN: "RRN Number",
  PAYMENT_FTR_NUMBER: "FTR Number",
  // Mandate details
  DETAIL_TRANSACTION_HISTORY: "Transaction history",
  DETAIL_DDA_REFERENCE_NO: "DDA reference no",
  DETAIL_MANDATE_STATUS: "Mandate status",
  DETAIL_STATUS: "Status",
  DETAIL_SERVICE: "Service",
  DETAIL_FREQUENCY: "Frequency",
  DETAIL_STUDENT_ID: "Student ID",
};

export const PAY_BY_LINK_CONSTANTS = {
  HEADER: "Payment Links",
  BREADCRUMB: "Payment Links",
  LINK_STATUS: "Link status",
  PAYMENT_STATUS: "Payment status",
  DATE_FROM: "Date from",
  DATE_TO: "Date to",
  STATUS_CANCELLED: "Cancelled",
  CANCEL_LINK_TITLE: "Cancel payment link",
  CANCEL_LINK_MESSAGE: "Are you sure you want to cancel payment link ?",
  CANCEL_LINK_CONFIRM: "Yes, cancel",
  CANCEL_LINK_BACK: "Back to details",
  CANCEL_SUCCESS: "Payment link cancelled successfully",
  CANCEL_ERROR: "Failed to cancel payment link. Please try again.",
  NO_DATA_MESSAGE: "No payment links found",
  NO_DATA_SUBTITLE: "You have no payment links yet",
  // Detail page strings
  DETAIL_PAYMENT_DETAILS: "Payment details",
  DETAIL_URL: "URL",
  DETAIL_ORDER_ID: "Order ID",
  DETAIL_LINK_STATUS: "Link status",
  DETAIL_PAYMENT_STATUS: "Payment status",
  DETAIL_EXPIRY_DATE: "Expiry date",
  DETAIL_DATE_CREATED: "Date created",
  DETAIL_AMOUNT: "Amount",
  DETAIL_CURRENCY: "Currency",
  DETAIL_TRANSACTION_DETAILS: "Transaction details",
  DETAIL_TRN: "Transaction reference number",
  DETAIL_TRANSACTION_DATE: "Transaction date",
  DETAIL_PAYMENT_METHOD: "Payment method",
  DETAIL_CUSTOMER_DETAILS: "Customer details",
  DETAIL_CUSTOMER_NAME: "Customer name",
  DETAIL_EMAIL: "Email",
  DETAIL_MOBILE_NO: "Mobile number",
  DETAIL_TRANSACTION_ID: "Transaction ID",
  DETAIL_MASKED_CARD: "Card number",
  DETAIL_CARD_ISSUER: "Card issuer",
  DETAIL_CARD_BRAND: "Card brand",
  DETAIL_SOURCE_OF_FUNDS: "Source of funds",
  DETAIL_RRN: "RRN",
  DETAIL_EPP_PROVIDER: "EPP provider",
  DETAIL_EPP_PLAN_ID: "EPP plan ID",
  DETAIL_FAILURE_REASON: "Failure reason",
  DETAIL_PRODUCT_DETAILS: "Product details",
  DETAIL_ITEM_TITLE: "Product name",
  DETAIL_ITEM_DESCRIPTION: "Description",
  DETAIL_ITEM_QUANTITY: "Quantity",
  DETAIL_ITEM_AMOUNT: "Amount",
  CANCEL_PAYMENT_LINK: "Cancel payment link",
  SESSION_EXPIRED_MSG:
    "Session expired. Please select a payment link from the list.",
  // Error messages
  ERROR_NOT_FOUND: "Payment link not found. It may have been deleted.",
  ERROR_ACCESS_DENIED: "You don't have access to this payment link.",
  ERROR_CANCEL_NOT_ALLOWED:
    "This payment link cannot be cancelled. It may already be paid or processing a payment.",
};

export const PRICING_CONSTANTS = {
  HEADER: "Pricing",
  BREADCRUMB: "Pricing",
  TAB_PRICING: "Pricing",
  TAB_PENDING_LIST: "Pending list",
  PENDING_COMING_SOON: "Pending list will be added in the next phase.",
  SUBMIT: "Submit",
  SUBMITTING: "Submitting...",
  SUBMIT_SUCCESS: "Pricing updated successfully",
  SUBMIT_ERROR: "Failed to update pricing. Please try again.",
  ACCESS_DENIED: "Pricing is available only for Super Admin.",
  LOADING: "Loading pricing data...",
  ERROR_REQUIRED: "This field is required",
  ERROR_NUMERIC: "Only numeric values are allowed",
  ERROR_RANGE: "Must be 0-100 with up to 2 decimal places",
};

export const GLOBAL_SIDEBAR_CONSTANTS = {
  HEADER: "Migrate from QKR",
  LOGOUT: "Log Out",
};

export const LANDING_PAGE_CONSTANTS = {
  WELCOME: "Welcome",
  SEARCH_LABEL: "Search",
  SEARCH_PLACEHOLDER: "Search by merchant ID or name",
  ALERT_SUCCESS1: "Merchants onboarding initiated successfully for",
  ALERT_SUCCESS2: "! Please check the status after some time.",
  ALERT_FAILURE: "Failed to onboard merchants. Error: ",
  ERROR_CONSOLE: "Error during onboarding:",
  ALERT_SOME_ERROR: "An error occurred during the onboarding process.",
};

export const MIGRATE_PAGE_CONSTANTS = {
  HEADER: "Migrate from QKR",
  BREADCRUMB_HOME: "Home",
  BREADCRUMB_MIGRATE: "Migrate from QKR",
  BODY1: "To migrate a merchant from QKR to Skiply,",
  BODY2: " please follow the below options",
  MIGRATE_BUTTON: "Migrate",
  MERCHANT_DETAILS: "Merchant Details",
  RECORD_NOT_FOUND: "Merchant record doesn’t exist in Qkr, please retry",
  ERROR_MIGRATING: "Failed to migrate merchant data.",
  MIGRATE_SUCCESS: "Successfully migrated",
};

export const CREATE_USER_CONSTANTS = {
  USER_PAGE_HEADER: "Create User",
  CONFIRM_PAGE_HEADER: "Confirm User Creation",
  EDIT_BUTTON: "Edit fields",
  SAVE_BUTTON: "Create",
  CONFIRM_BUTTON: "Confirm",
};

export const USER_MANAGEMENT_CONSTANTS = {
  HEADER: "User Management",
  BREADCRUMB_HOME: "Home",
  BREADCRUMB_USER_MANAGEMENT: "User Management",
  CREATE_USER: "Create User",
  SESSION_EXPIRED: "Session needs to be refreshed",
  SESSION_EXPIRED_MESSAGE: "Session has been expired. Please login again.",
  SESSION_EXPIRED_BUTTON: "Done",
  SUCCESS_MESSAGE: "User Creation Successfully",
};

export const GLOBAL_SEARCH_CONSTANTS = {
  HEADER: "Search",
  SEARCH_PLACEHOLDER: "Search for something...",
  MERCHANTS: "Merchants",
  EMPTY_TITLE: "No recent searches",
  EMPTY_MESSAGE: "Search by merchant name, merchant ID",
};

export const STUDENT_CONFIG_CONSTANTS = {
  HEADER: "Configurations",
  BREADCRUMB_HOME: "Home",
  BREADCRUMB_CONFIGURATIONS: "Configurations",
  CONFIG_FAILURE: "School configuration not updated Successfully",
  CONNFIG_SUCCESS: "School configuration updated Successfully",
  GRADE_ENABLED: "Student Grade Update Request enabled successfully",
  GRADE_DISABLED: "Student Grade Update Request disabled successfully",
  CONVIENCE_FEE_LESSER: "Convenience Fee Value Must Be Greater Than 0",
  CONVIENCE_FEE_GREATER:
    "Convenience Fee Maximum Amount Must Be Greater Than 0",
  GENERAL_HEADER: "General",
  SPECIFY_TYPE: "Please specify the type of integration with QKR",
  AUTH_METHODS: "Select the authentication methods",
  ENABLE_OUTSTANDING: "Enable outstanding fee on products ?",
  UPDATE_OUTSTANDING: "Update outstanding fee balance ?",
  ALLOW_PARTIAL_PAYMENT: "Allow users to enter Partial Payments",
  TOOLIP_HEADER1: "Display prompt to udpate student’s grade",
  TOOLIP_CONTENT1:
    "Enabling this switch will display a pop-up requesting the student grade to be updated in the student profile.",
  TOOLIP_HEADER2: "Hide prompt to update student’s grade",
  TOOLIP_CONTENT2:
    "Disabling this switch will hide the pop-up requesting the student grade to be updated in the student profile.",
  TOOLTIP_HEADER3: "Academic Year Annual Update",
  TOOLTIP_CONTENT3:
    "Please toggle the switch on and off to re-trigger this prompt for each new academic year.",
  ADDRESS_REQUIRED: "Address1 is required.",
  INVALID_PHONE_NUMBER: "Invalid phone format.",
  FIRSTNAME_REQUIRED: "Primary Contact First Name is required.",
  LEGALNAME_REQUIRED: "Primary Legal Name is required.",
  PRIMARY_WEB_REQUIRED: "Primary Website URL is required.",
  COUNTRY_CODE_REQUIRED: "Country code must be exactly 2 characters.",
  GRADE_HEADER: "Student Grade Update Request",
  GRADE_TOGGLE: "Display pop-up prompting all users to update student grade",
  GRADE_SUCCESS_MSG: "Only applicable for non-integrated school",
  ENABLE_STUDENT_GRADE: "Enabled student grade update request",
  SEARCH_CRITERIA_HEADER: "Student Search Criteria",
  SEARCH_CRITERIA_HEADER_TEXT:
    "Choose the criteria for student search in the mobile app",
  EPP_HEADER: "EPP Configuration",
  NO_EPP_HEADER: "No EPP Configurations Available",
  PAYMENT_SETTINGS: "Payment Settings",
  MERCHANT_DETAILS: "Merchant Details",
  CONVIENCE_FEES: "Convenience Fee",
  WEB_CHECKOUT: "Web Checkout Details",
  WEB_CHECKOUT_PAYMENT_METHOD_HEADER:
    "Choose the payment methods for web checkout",
  OTT_CHALLENGE: "OTT Challenge",
  OAUTH_CONFIGURATION: "OAuth Configuration",
  MERCHANT_TYPE: "Merchant Type",
  PRIMARY_BUTTON: "Save",
  SECONDARY_BUTTON: "Cancel",
};

export const QKR_LOGIN_URL = process.env.REACT_APP_QKR_LOGIN_URL;
export const FACEBOOK_LINK = "https://www.facebook.com/SkiplyApp/";
export const LINKEDIN_LINK = "https://www.linkedin.com/showcase/skiply.ae/";
export const INSTAGRAM_LINK = "https://www.instagram.com/skiplyapp/";

export const SCHOOL_LOGO_DEFAULT = require("../images/Avatar.png");
export const LOGIN_CAROUSEL_INTERVAL = 2000;
export const LOGIN_CAROUSEL_ITEM_HEIGHT = 220;
export const LOGIN_CAROUSEL_VISIBLE_COUNT = 5;
export const LOGIN_CAROUSEL_HEIGHT = 76;
export const LOGIN_CAROUSEL_WIDTH = 76;
export const STUDENT_DATA_FILE_MAX_SIZE = 5767168; // 5 MB in bytes
export const API_CONTEXT_TYPE = "application/json";
export const API_AUTH_TOKEN =
  "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh";
export const API_METHOD_POST = "POST";
export const API_METHOD_GET = "GET";
export const ACCOUNT_LOCKED = "ACCOUNT_LOCKED";
export const SEND_OTP_LIMIT = "SEND_OTP_LIMIT";
export const ADMIN_TYPE = {
  SCHOOL_ADMIN: "SCHOOLADMIN",
  SUPER_ADMIN: "SUPERADMIN",
  SALES_ADMIN: "SALESADMIN",
};

export const HOMEPAGE_TILELIST = [
  {
    title: "Skiply Portal",
    body: "Manage trips seamlessly with digital consent forms and signatures",
    image: require("../images/businessPortalImg.png"),
    activeImage: require("../images/businessPortalImgActive.png"),
    link: "/skiply-portal/Login",
    newTab: false,
    isActive: true,
    width: "140px",
  },
  {
    title: "Qkr!",
    body: "Manage trips seamlessly with digital consent forms and signatures",
    image: require("../images/qkrPortalImg.png"),
    activeImage: require("../images/qkrPortalImgActive.png"),
    link: "https://qkr-mss.qkrschool.com/qkr_mss/index.html",
    newTab: true,
    isActive: true,
    width: "220px",
  },
  {
    title: "Pay by Link",
    body: "Manage trips seamlessly with digital consent forms and signatures",
    image: require("../images/payByLinkImg.png"),
    activeImage: require("../images/payByLinkImgActive.png"),
    link: "/skiply-portal/Login",
    newTab: false,
    isActive: true,
    width: "180px",
  },
  {
    title: "Dashboard & Ecosystem",
    body: "Manage trips seamlessly with digital consent forms and signatures",
    image: require("../images/dashboardEcosystemImg.png"),
    activeImage: require("../images/dashboardEcosystemImgActive.png"),
    link: "/skiply-portal/Login",
    newTab: false,
    isActive: true,
    width: "212px",
  },
  {
    title: "Onboarding",
    body: "Get your institution listed and start accepting payments",
    image: require("../images/onboardingImg.png"),
    activeImage: "",
    link: "",
    newTab: true,
    isActive: false,
    width: "160px",
  },
  {
    title: "Templates and Tutorials",
    body: "Access useful templates and step-by-step tutorials for easy setup",
    image: require("../images/templatesTutorialsImg.png"),
    activeImage: require("../images/activeTemplatesTutorials.png"),
    link: "/skiply-portal/Tutorials",
    newTab: false,
    isActive: true,
    width: "184px",
  },
  {
    title: "ERP Portal",
    body: "Choose your ERP system vendor for seamless integration with Skiply",
    image: require("../images/erpPortalImg.png"),
    activeImage: "",
    link: "",
    newTab: true,
    isActive: false,
    width: "160px",
  },
  {
    title: "Educational Services",
    body: "Discover specialized banking solutions designed for educational institutions",
    image: require("../images/educationalServicesImg.png"),
    activeImage: "",
    link: "",
    newTab: true,
    isActive: false,
    width: "200px",
  },
];

export const HOMEPAGE_FOOTER_LINKS = [
  {
    text: "Terms & Conditions",
    link: "https://skiply.ae/files/Skiply-T&C.pdf",
  },
  {
    text: "Privacy Policy",
    link: "https://www.rakbank.ae/en/privacy-policy",
  },
  {
    text: "Contact us",
    link: "mailto:contactus@skiply.ae",
  },
];

export const LOGINPAGE_TILELIST = [
  {
    id: 0,
    image: require("../images/installmentsRewardsImg.png"),
    activeImage: require("../images/installmentsRewardsImgActive.png"),
    content: "Installments and rewards",
  },
  {
    id: 1,
    image: require("../images/reportsImg.png"),
    activeImage: require("../images/reportsImgActive.png"),
    content: "Reports",
  },
  {
    id: 2,
    image: require("../images/erpIntegrationImg.png"),
    activeImage: require("../images/erpIntegrationImgActive.png"),
    content: "ERP integration",
  },
  {
    id: 3,
    image: require("../images/digitalSignaturesImg.png"),
    activeImage: require("../images/digitalSignaturesImgActive.png"),
    content: "Digital signatures",
  },
  {
    id: 4,
    image: require("../images/notificationImg.png"),
    activeImage: require("../images/notificationImgActive.png"),
    content: "Notifications",
  },
  {
    id: 5,
    image: require("../images/studentMgmtImg.png"),
    activeImage: require("../images/studentMgmtImgActive.png"),
    content: "Students management",
  },
  {
    id: 6,
    image: require("../images/tripsImg.png"),
    activeImage: require("../images/tripsImgAcive.png"),
    content: "Trips",
  },
  {
    id: 7,
    image: require("../images/secureTxnImg.png"),
    activeImage: require("../images/secureTxnImgActive.png"),
    content: "Secure transactions",
  },
];

export const DISABLE_GRADE_HEADER = "Hide Prompt to Update Student’s Grade";
export const DISABLE_GRADE_BODY = [
  "Disabling this switch will hide the pop-up requesting the student grade to be udpated in the student profile.",
  "Please note by selecting ‘Yes’, all other changes on this page will be saved.",
  "Do you want to continue?",
];
export const ENABLE_GRADE_HEADER = "Display Prompt to Update Student’s Grade";
export const ENABLE_GRADE_BODY = [
  "Enabling this switch will display a pop-up requesting the student grade to be udpated in the student profile.",
  "Please note by selecting ‘Yes’, all other changes on this page will be saved.",
  "Do you want to continue?",
];

export const STUDENT_DATA_CONSTANTS = {
  HEADER: "Student data",
  BREADCRUMB_HOME: "Home",
  BREADCRUMB_CONFIGURATIONS: "Configurations",
  FILESTATUS_COMPLETED: "COMPLETED",
  FILESTATUS_AUTORETIRED: "AUTORETRIED",
  FILESTATUS_ABORTED: "ABORTED",
  FILESTATUS_PROGRESS: "PROGRESS",
  FILESTATUS_RETRY: "RETRY",
  FILESTATUS_PREPARE: "PREPARE",
  FILESTATUS_ERROR: "ERROR",
  PREPARING_STATUS: "Preparing to start upload",
  ACTIVITY_NO_RECORD: "No records",
  DOWNLOAD_TEMPLATE_HEADER: "1. Download & complete template",
  ACTIVITY_STATUS_HEADER: "Activity Status",
  UPLOAD_STUDENT_DATA: "Upload Student Data",
  UPLOAD_STUDENT_RECORDS: "2. Upload student records",
  ANOTHER_UPLOAD_MSG:
    "Another upload is in progress. Database update cannot be performed at this moment. Please try after sometime.",
  STUDENT_DATA_UPLOAD: "Student Data Upload",
  STUDENT_MANAGEMENT: "Student Management",
  ERROR_PROCESS_FILE: "Some issue occurred. Please try again",
  DATA_IN_PROGESS: "Your data upload is in progress…",
  SUBMIT_DATA: "Submit to update database",
  ERROR_IN_RECORDS:
    "Errors found in the record. Please modify the validated template and upload again",
  VALIDATE_TEMPLATE: "Validate template for errors",
  UPLOAD_TEMPLATE: "Upload the template",
  UPLOAD_TEMPLATE_FILE: "Upload template file",
  TEMPLATE_MODES: "XLS under 2MB",
  SELECT_UPLOAD_TYPE: "Select the type and upload template",
  INFORMATION: "Information",
  ERROR_ALREADY_EXISTS:
    "We identified some students which are already available in the Database, do you want to update them.",
  CANCEL: "Cancel",
};

export const STUDENT_UPLOAD_TILES = [
  {
    title: "Bulk Add/Modify.xls",
    description: "When you need to add or modify student records",
    action: "UPDATE",
  },
  {
    title: "Bulk Delete.xls",
    description:
      "Download and complete when you need to delete or remove student records.",
    action: "DELETE",
  },
];

export const STUDENT_DATA_ALERTMSG = {
  getListFailureMsg: "Student data not found, Hence unable to data in the grid",
  processSuccessMsg: "Data has been validated successfully",
  uploadMessage: "File validated successfully",
  uploadMessageFailure:
    "Error found in the records.To know the error records, click the below link. Please fill the correct information and upload again.",
  commitSuccessMsg: "File has been processed successfully",
  commitFailureMsg: "Student data not committed successfully",
  abortSuccessMessage: "File has been aborted successfully",
  abortFailureMessage: "File abort failed",
  fileSizeMsg: "File size cannot exceed 1MB",
  noFileErr:
    "Please upload a file and then click on Update Student List button",
  noDataInExcelMsg: "Uploaded file doesn't have student data to process",
  duplicateStudentMsg:
    "Excel has duplicate student id's . Please correct it and upload again.",
  sessionExpiry: "Session has been expired. Please login again.",
};

export const CREATE_STUDENT_CONSTANTS = {
  HEADER: "Student addition",
  CREATE_BUTTON: "Add",
  MODIFY_RECORDS: "Modify the record?",
  UPDATE_BUTTON: "Update",
};

export const REPORTS_PAGE_CONSTANTS = {
  HEADER: "Reports",
  BREADCRUMB_HOME: "Home",
  BREADCRUMB_REPORTS: "Reports",
  BUTTON_EDIT: "Edit",
  BUTTON_DELETE: "Delete",
};

export const BREADCRUMB_HOME = "Home";
export const BREADCRUMB_MERCHANTS = "Merchants";
export const CREATE_USER_BUTTON = "Create User";
export const CREATE_PRODUCT_BUTTON = "New Product";
export const CREATE_CATEGORY_BUTTON = "New Category";
export const BREADCRUMB_PRODUCT = "Products";
export const BREADCRUMB_CATEGORY = "Categories";

export const REGEX_VALIDATIONS = {
  // eslint-disable-next-line no-useless-escape
  alpha: /^[a-zA-Z\s]*$/g,
  alphaWithSpace: /^[a-z A-Z\s]*$/g,
  alphaWithInternationalSpace: /^[\p{L}\s'`\-]*$/gu,
  dateProgressive: /^(?:\d{0,2}(?:\/\d{0,2}(?:\/\d{0,4})?)?)?$/g,
  // eslint-disable-next-line no-useless-escape
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/g,
  password: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/g,
  alphanumericWithSpecialChar: /^[A-Za-z0-9_@./#&+-]*$/g,
  phoneumber: /^((\+971)|0)?[0-9]{9}$/g,
  forgotPassword:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/g,
  removeSpace: /\s/g,
  onlyDigits: /^[0-9]*$/g,
  alphaNumeric: /^[a-zA-Z0-9\s]*$/g,
};

export const NOTIFICATION_CONSTANTS = {
  HEADER: "Send notifications and add emojis",
  CURRENT_TAB: "Send notifications",
};

export const MARKETPLACE_CONSTANTS = {
  HEADER: "Marketplace",
  PRODUCTS: "Products",
  CATEGORIES: "Categories",
  PRODUCT_ID: "Product ID",
  PRODUCT_NAME: "Product name",
  CATEGORY: "Category",
  MERCHANT_ID: "Merchant Name",
  CURRENCY: "Currency",
  RECOMMENDED: "Recommended",
  RECOMMENDED_DETAILS: "Display as recommended",
  ENABLED: "Enabled",
  ENABLED_DETAILS: "Show product in catalog",
  UPLOAD_IMAGE: "Upload image",
  UPLOAD_IMAGE_DETAILS: "PNG or JPEG under 2MB",
  IMAGES: "Images",
  SPECIFICATION: "Specifications",
  ADD_SPECIFICATION: "Add specification",
  VARIANT: "Variants",
  ADD_VARIANT: "Add variant",
  SAVE_BUTTON: "Save Product",
  TITLE_LABEL: "Title",
  DESCRIPTION_LABEL: "Value",
  DESCRIPTION_TITLE: "Description",
  DESCRIPTION_SAMPLE: "Example: AED 3,000 or 12 months",
  TITLE_AR_LABEL: "Title AR",
  DESCRIPTION_AR_LABEL: "Value AR",
  DESCRIPTION_TITLE_AR: "Description AR",
  DESCRIPTION_AR_SAMPLE: "Example: 3000 درهم إماراتي أو 12 شهرًا",
  VARIANT_ID_LABEL: "Variant ID",
  VARIANT_PRICE_LABEL: "Price",
  VARIANT_FORM_LABEL: "Form",
  VAT_SELECTION: "Price Inclusive of Vat",
  DEFAULT_VARIANT: "Default variant",
  DEFAULT_VARIANT_DETAILS: "You can set only one variant as default",
  ENABLED_VARIANT: "Enabled",
  ENABLED_VARIANT_DETAILS: "Show variant in catalog",
  VARIANT_DESCRIPTION: "Variant description",
  VARIANT_CODE_LABEL: "Variant Code",
  VARIANT_NAME_LABEL: "Variant Name",
  DISPLAY_PERIOD: "Display period",
  START_DATE: "Start date",
  END_DATE: "End date",
  DATE_FORMAT: "dd/MM/yyyy",
  GRADE: "Grade",
  DIVISION: "Division",
  OVERRIDE: "Override",
};

export const FORGOT_PASSWORD_STEPPERS = [
  {
    stepId: 1,
    stepName: "Enter Email ID",
  },
  {
    stepId: 2,
    stepName: "Enter Verification Code",
  },
  {
    stepId: 3,
    stepName: "Create a New Password",
  },
];

export const FORGOT_PASSWORD_INSTRUCTIONS = [
  "1 lower case character",
  "1 special character",
  "1 upper case character",
  "8 characters minimum",
];

export const FORGOT_PASSWORD_INITIAL_STATE = {
  validated: false,
  adminEmailId: "",
  emailFailureMsg: "",
  emailSuccess: false,
  emailFailure: false,
  currentStep: 1,
  otp: "",
  newPwd: "",
  confirmPwd: "",
  successCode: "",
  otpToken: "",
  mail: "",
  successCodeEmail: "",
  otpSuccess: false,
  otpFailure: false,
  otpSuccessMsg: "Verify OTP Successfull",
  otpFailureMsg: "Verify OTP UnSuccessfull",
  emptyFieldMessage: "New password and confirm password cannot be empty",
  emptyfield: false,
  matchMessage: "New password and confirm password does not match",
  match: false,
  showPass: false,
  updatePwdSuccess: false,
  updatePwdFailure: false,
  pwdFailure: false,
  pwdFailureMsg:
    "Validation failure. Password must be between 8 and 16 characters, contain at least one number, one alphabetic character and one special character.",
};

export const SAMPLE_PRODUCT_IMG = require("../images/sample_product.png");

export const PRODUCT_HEADERS = {
  "Content-Type": "application/json",
  "skiply-client": "skiply-portal",
};

export const MARKETPLACE_CURRENCY_LIST = [
  "AED",
  // 'EUR',
  // 'USD'
];

export const TUTORIALS_TILELIST = [
  {
    title: "Skiply App Journey",
    body: "Explore the complete Skiply app experience from onboarding to everyday use",
    image: require("../images/templatesTutorialsImg.png"),
    activeImage: require("../images/activeTemplatesTutorials.png"),
    link: "https://skiply.ae/files/Skiply-Tutorial.pdf",
    newTab: true,
    isActive: true,
    width: "184px",
  },
  {
    title: "Student Enrollment Tutorial",
    body: "Learn how to enroll and manage students step-by-step with Skiply",
    image: require("../images/templatesTutorialsImg.png"),
    activeImage: require("../images/activeTemplatesTutorials.png"),
    link: "https://skiply.ae/files/Skiply-Student-Enrollment-Tutorial.pdf",
    newTab: true,
    isActive: true,
    width: "184px",
  },
];
